// Statuses are tenant-configurable (custom names/order via the candidate-status
// admin page), so a badge's color can't be guessed from hardcoded English names
// ("shortlisted", "interviewed", ...) — that breaks the moment a status is renamed
// or a custom one is added. Color is instead the status's position in an
// already sequence-sorted list of the tenant's statuses, cycled through
// PIPELINE_ACCENTS (see pages/admin/dashboard/common.js). Mirrors the fix already
// applied in pages/admin/dashboard/index.jsx.

const matchKeys = (status) =>
  [status?.id, status?.code, status?.name, status?.code?.toLowerCase?.(), status?.name?.toLowerCase?.()].filter((key) => key != null);

/**
 * @param {object|string} status - the candidate's status (object with id/code/name, or a plain status string/name)
 * @param {Array} statusList - the tenant's statuses, already sorted by `sequence`
 * @returns {number} index into statusList (and so into PIPELINE_ACCENTS), 0 if not found
 */
export const getStatusColorIndex = (status, statusList = []) => {
  if (!Array.isArray(statusList) || statusList.length === 0) return 0;

  const needle = typeof status === "string" ? status.toLowerCase() : null;
  const keys = needle ? [needle] : matchKeys(status);

  const index = statusList.findIndex((candidate) => {
    const candidateKeys = matchKeys(candidate).map((key) => (typeof key === "string" ? key.toLowerCase() : key));
    return keys.some((key) => candidateKeys.includes(typeof key === "string" ? key.toLowerCase() : key));
  });

  return index === -1 ? 0 : index;
};
